Vue.component('ack-features-section', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-features-section',
	props: {
		isVisible: {
			type: Boolean,
			required: false,
			default: true,
		},
		title: {
			type: String,
			required: true,
		},
		sectionClass: {
			type: String,
			required: false,
			default: '',
		},
		titleClass: {
			type: String,
			required: false,
			default: '',
		},
		featureItems: {
			type: Array,
			required: true,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
	},
});
